import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const usePdfStore = create()(
  persist(
    (set) => ({
      pdfUrl: "",
      pdfPassword: "",
      docType: "",
      setPdfData: (url, password, docType) => set({ pdfUrl: url, pdfPassword: password, docType: docType }),
    }),
    {
      name: "pdf-settings",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
